import { Feed, Icon, Message, Popup } from "semantic-ui-react"
import BifrostButton from "../../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostWaringIcon from "../../../BifrostElementComponent/BifrostWarningIcon/BifrostWaringIcon"
import Loader from "../../../BifrostPageComponent/Loader/Loader"
import FTPModal from "./FTPModal"
import { useFTP } from "./hooks/useFTP"

const FTP = ({ device, deviceConfigData }) => {
	const { state, openWarnningModal, confirmHandler, cancelHandler } = useFTP(device, deviceConfigData)

	return (
		<>
			<Feed.Event className="device-event-margin">
				<Feed.Content>
					<Feed.Summary>FTP {state.isSyncError && <BifrostWaringIcon content="Could not read FTP from device" />}</Feed.Summary>
					<Feed.Extra text className={"device-change-disabled"} style={{ justifyContent: "space-between" }}>
						<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
							<Message
								size="mini"
								content={state.statusMessageContent}
								positive={state.statusMessagePositive}
								negative={state.statusMessagePositive !== null && !state.statusMessagePositive}
								style={{ paddingTop: "7px", paddingBottom: "9px", marginBottom: "0px" }}
							/>
							{state.showDisableButton && (
								<Popup
									content={"Cannot disable FTP while in session"}
									wide="very"
									on={"click"}
									disabled={!state.showPopup}
									trigger={
										<div>
											<BifrostButton size="medium" color="red" disabled={state.isDisabledButton} style={{ marginLeft: "10px" }} onClick={() => openWarnningModal(true)}>
												<Icon name="stop" style={{ margin: "0px", opacity: "1" }} />
											</BifrostButton>
										</div>
									}
								/>
							)}
							{state.isLoading && <Loader backgroundColor="white" inverted size="small" />}
							{state.isSuccess && <Icon name="check circle outline" size="large" style={{ color: "#39C4AA" }} />}
							{state.isError && <Icon name="close" size="large" style={{ color: "darkred" }} />}
						</div>
					</Feed.Extra>
				</Feed.Content>
			</Feed.Event>
			<FTPModal states={{ state }} actions={{ confirmHandler, cancelHandler }} />
		</>
	)
}

FTP.propTypes = {}

export default FTP
